import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'attr-autocomplete',
  templateUrl: './attr-autocomplete.component.html'
})
export class AttrAutocompleteComponent implements OnChanges {
  @Input() dataSource: any[] = [];
  @Input() selectedId: number | undefined;
  @Output() selectedIdChange = new EventEmitter<number>();
  @Input() disabled: boolean = false;
  @Input() placeholder: string = "Atributo";
  @Input() label: string = "";
  @Output() multipleSelecChange = new EventEmitter<number>();

  control = new FormControl('');
  filteredOptions!: Observable<{ id: number, name: string }[]>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource'] || changes['selectedId']) {
      const selectedItem = this.dataSource.find(item => item.id === this.selectedId);
      if (selectedItem) {
        this.control.setValue(selectedItem);
      } else {
        this.control.setValue('');
      }

      this.filteredOptions = this.control.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name) : this.dataSource.slice())
      );
    }
  }

  displayFn(option: { id: number, name: string } | string): string {
    return typeof option === 'string' ? option : option?.name;
  }

  private _filter(name: string): { id: number, name: string }[] {
    const filterValue = name.toLowerCase();
    return this.dataSource.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  onOptionSelected(event: any) {
    const selected = event.option.value;
    this.selectedId = selected.id;
    this.selectedIdChange.emit(this.selectedId);
  }

  limpiar() {
    this.control.setValue('');
    this.selectedId = 0;
    this.selectedIdChange.emit(0);
  }
}